import { ChangeDetectorRef, Component, ElementRef, Injectable, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../../../../common/services/Common.service';
import { EmailService } from '../../../../../../common/services/Email.service';
import { BsModalService } from 'ngx-bootstrap';
import { EmailConst } from './email.const';
import { TableAction } from '../../../../../../components/table-component/table.const';
import { BaseListComponent } from '../../../../../../components/base-list.component';
import { FormFieldType, ModalType } from '../../../../../../components/modals/modal-form-template/modal-form.const';
import { isEmail, isNumber } from '../../../../../../common/utils/validate';
import { TemplateType } from '../../other/template/template.const';
import * as _ from 'lodash';

@Component({
  selector: 'settings-conversation-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css'],
  providers: [CommonService, EmailService, BsModalService],
})
@Injectable()
export class EmailComponent extends BaseListComponent {
  @ViewChild('templateAccount') templateAccount: ElementRef;
  public tab = 'account';
  public files: any = [];
  public allTemplate: any = [];
  public allType: any = [];

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected modalService: BsModalService,
    protected toastr: ToastrService,
    private emailService: EmailService
  ) {
    super(changeDetector, toastr, modalService);
    this.displayColumns = EmailConst.displayColumns();
  }

  ngOnInit() {
    Promise.all([this.loadData(), this.loadTemplate()]).then(() => {});
  }

  async loadData(request: any = {}, sort: any = {}) {
    this.data = [];
    this.emailService.listAccount(request).subscribe(
      res => {
        if (res.status == 200 && res.error == false) {
          this.data = res.data.list || [];
          this.initPage(res.data.total);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }
  async loadTemplate(request: any = {}, sort: any = {}) {
    this.data = [];
    this.emailService.listTemplate(request).subscribe(
      res => {
        if (res.status == 200 && res.error == false) {
          const templateList = [{ id: '', text: 'Mẫu sử dụng', type: null }];
          res.data.forEach(e => {
            templateList.push({
              id: e.id.toString(),
              text: e.template_name,
              type: e.type,
            });
          });
          this.allTemplate = templateList.filter(t => t.type == TemplateType.Email);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  async openConfirmDelete(id) {
    this.delete_id = id;
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      await this.submitDelete();
    }
  }

  async submitDelete() {
    this.emailService.deleteAccount(this.delete_id).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.throwError('Xóa không thành công!');
          } else {
            this.throwSuccess('Xóa thành công!');
            this.loadData();
          }
        }
      },
      error => {
        this.throwError('Xóa không thành công!');
      }
    );
  }

  async add() {
    this.model.OUTGOING_EMAIL_ADDRESS = this.model.EMAIL_ADDRESS;
    this.model.OUTGOING_PASSWORD = this.model.INCOMING_PASSWORD;
    const payload = _.assign({}, this.model);
    delete payload.Label_INCOMING;
    delete payload.Label_OUTGOING;
    delete payload.LINE;
    payload['AUTO_REPLY_EMAIL'] = this.model['AUTO_REPLY_EMAIL'] ? 1 : 0;
    if (!this.model['AUTO_REPLY_EMAIL']) {
      payload['AUTO_REPLY_EMAIL_TEMPLATE_ID'] = '';
    }
    this.emailService.createAccount(payload).subscribe(
      res => {
        if (res.status === 200 && !res.error) {
          this.throwSuccess('Thêm mới thành công!');
          this.closeModal();
          this.loadData();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async edit() {
    this.message = null;
    this.model.OUTGOING_EMAIL_ADDRESS = this.model.EMAIL_ADDRESS;
    this.model.OUTGOING_PASSWORD = this.model.INCOMING_PASSWORD;
    const payload = _.assign({}, this.model);
    delete payload.Label_INCOMING;
    delete payload.Label_OUTGOING;
    delete payload.LINE;
    payload['AUTO_REPLY_EMAIL'] = this.model['AUTO_REPLY_EMAIL'] ? 1 : 0;
    if (!this.model['AUTO_REPLY_EMAIL']) {
      payload['AUTO_REPLY_EMAIL_TEMPLATE_ID'] = '';
    }
    delete payload.ID;
    delete payload.CREATED_DATE;
    delete payload.USER_CREATED;
    delete payload.TENANT_ID;
    delete payload.INCOMING_STATUS;
    delete payload.SERVICE_GROUP;
    delete payload.OUTGOING_STATUS;
    this.emailService.updateAccount(this.model.ID, payload).subscribe(
      res => {
        if (res.status === 200 && !res.error) {
          this.throwSuccess('Cập nhật thành công!');
          this.closeModal();
          this.loadData();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async setUpModel() {
    this.modelContent = {
      type: ModalType.Primary,
      title: this.typeModal === 'add' ? 'Thêm mới tài khoản email' : 'Cập nhật tài khoản email',
      submit_title: this.typeModal === 'add' ? 'Thêm mới' : 'Cập nhật',
    };
    this.modelDisplay = [
      {
        key: 'ACCOUNT_NAME',
        label: 'Tên tài khoản',
        type: FormFieldType.Text,
        value: this.model.ACCOUNT_NAME,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
      },
      {
        key: 'EMAIL_ADDRESS',
        label: 'Địa chỉ email',
        type: FormFieldType.Text,
        value: this.model.EMAIL_ADDRESS,
        required: true,
        disabled: false,
        width: '1/2',
        order: 2,
      },
      {
        key: 'INCOMING_PASSWORD',
        label: 'Mật khẩu',
        type: FormFieldType.Hidden,
        value: this.model.INCOMING_PASSWORD,
        required: true,
        disabled: false,
        width: '1/2',
        order: 3,
      },
      {
        key: 'Label_INCOMING',
        label: 'Cấu hình INCOMING',
        type: '',
        value: '',
        required: false,
        disabled: false,
        width: 'full',
        order: 4,
      },
      {
        key: 'INCOMING_SERVER',
        label: 'Địa chỉ server',
        type: FormFieldType.Text,
        value: this.model.INCOMING_SERVER,
        required: true,
        disabled: false,
        width: '1/2',
        order: 5,
      },
      {
        key: 'INCOMING_SERVER_PORT',
        label: 'Port',
        type: FormFieldType.Text,
        value: this.model.INCOMING_SERVER_PORT,
        required: true,
        disabled: false,
        width: '1/2',
        order: 6,
      },
      {
        key: 'INCOMING_SERVER_PROTOCOL',
        label: 'Giao thức',
        type: FormFieldType.Text,
        value: this.model.INCOMING_SERVER_PROTOCOL,
        required: true,
        disabled: false,
        width: '1/2',
        order: 7,
      },
      {
        key: 'INCOMING_SERVER_AUTH',
        label: 'Xác thực server',
        type: FormFieldType.Text,
        value: this.model.INCOMING_SERVER_AUTH,
        required: true,
        disabled: false,
        width: '1/2',
        order: 8,
      },
      {
        key: 'Label_OUTGOING',
        label: 'Cấu hình OUTGOING',
        type: '',
        value: '',
        required: false,
        disabled: false,
        width: 'full',
        order: 9,
      },
      {
        key: 'OUTGOING_SERVER',
        label: 'Địa chỉ server',
        type: FormFieldType.Text,
        value: this.model.OUTGOING_SERVER,
        required: true,
        disabled: false,
        width: '1/2',
        order: 10,
      },
      {
        key: 'OUTGOING_SERVER_PORT',
        label: 'Port',
        type: FormFieldType.Text,
        value: this.model.OUTGOING_SERVER_PORT,
        required: true,
        disabled: false,
        width: '1/2',
        order: 11,
      },
      {
        key: 'OUTGOING_SERVER_PROTOCOL',
        label: 'Giao thức',
        type: FormFieldType.Text,
        value: this.model.OUTGOING_SERVER_PROTOCOL,
        required: true,
        disabled: false,
        width: '1/2',
        order: 12,
      },
      {
        key: 'OUTGOING_SERVER_AUTH',
        label: 'Xác thực server',
        type: FormFieldType.Text,
        value: this.model.OUTGOING_SERVER_AUTH,
        required: true,
        disabled: false,
        width: '1/2',
        order: 13,
      },
      {
        key: 'LINE',
        label: '',
        type: FormFieldType.Line,
        value: '',
        required: false,
        disabled: false,
        width: 'full',
        order: 14,
      },
      {
        key: 'AUTO_REPLY_EMAIL',
        label: 'Tự động trả lời',
        type: FormFieldType.Switch,
        value: this.model.AUTO_REPLY_EMAIL,
        required: false,
        disabled: false,
        width: 'full',
        order: 15,
        options: {
          checkInline: true,
        },
      },
    ];

    if (this.model.AUTO_REPLY_EMAIL) {
      this.modelDisplay.push({
        key: 'AUTO_REPLY_EMAIL_TEMPLATE_ID',
        label: 'Mẫu sử dụng',
        type: FormFieldType.Select2,
        value: this.model.AUTO_REPLY_EMAIL_TEMPLATE_ID,
        required: true,
        disabled: false,
        condition: [{ key: 'AUTO_REPLY_EMAIL', condition: '!=', value: '' }],
        width: 'full',
        order: 16,
        options: {
          data: this.allTemplate,
          select2Options: {
            placeholder: { id: '', text: 'Mẫu sử dụng' },
          },
        },
      });
    }
  }

  async handleAction(type: any, item?: any) {
    this.model = {};
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-lg',
      keyboard: false,
    };
    switch (type) {
      case TableAction.add:
        this.typeModal = 'add';
        await this.setUpModel();
        this.openModal(this.templateAccount, config, null, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.edit:
        Object.keys(item).forEach(key => {
          if (item[key] !== null && item[key] !== undefined) {
            this.model[key] = item[key];
          }
        });
        this.typeModal = 'edit';
        await this.setUpModel();
        this.openModal(this.templateAccount, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.delete:
        this.openConfirmDelete(item.ID).then();
        break;
    }
  }

  async handleSubmit(item?: any) {
    this.model = _.merge({}, this.model, item);
    if (this.typeModal === 'add') {
      await this.add();
    } else if (this.typeModal === 'edit') {
      await this.edit();
    }
  }

  async onChangeValueModel(key, item?: any) {
    this.model = _.merge({}, this.model, item);
    this.message = null;
    switch (key) {
      case 'INCOMING_SERVER_PORT':
      case 'OUTGOING_SERVER_PORT':
        if (isNumber(this.model[key])) {
          this.model[key] = parseFloat(this.model[key]);
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: key === 'INCOMING_SERVER_PORT' ? 'INCOMING Port phải là số!' : 'OUTGOING Port phải là số!',
          };
        }
        break;
      case 'EMAIL_ADDRESS':
        if (!isEmail(this.model[key])) {
          this.message = {
            class: 'alert dark alert-danger',
            content: 'Email không đúng định dạng!',
          };
        }
        break;
    }
    await this.setUpModel();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/conversation/email/email.component.ts